import styled from 'styled-components'

const BlackButtonUi = styled.button`
  font-family: Inter, Helvetica, Arial, sans-serif;
  font-size: 14px;
  margin-right: 2px;
  margin-left: 2px;
  color: black;
  font-weight: 400;
  border-radius: 3px;
  background-color: #ffffff;
  box-shadow: ${({ shadow }) => (shadow ? '0 2px 3px 0 #d5e0e8' : 'none')};
  border: solid 1px black;
  text-align: center;
  padding: ${({ wide }) => (wide ? '6px 20px' : '6px 10px')};
  cursor: pointer;
  line-height: 1.42857143;
  outline: none;
  transition: background-color 0.25s ease;
  &:disabled {
    opacity: 0.5;
    cursor: default;
    pointer-events: none;
  }
  ${({ styles = {} }) => styles}
`

export default BlackButtonUi
